import React from "react";
import { Spinner } from "react-bootstrap";

const AdminLoader = ({ type = 'contained' }) => {
  return (
    <div className={`loading-container ${type}`}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default AdminLoader;